export default __webpack_public_path__ + "static/media/organiseren.5695394c.png";